
import {createSlice} from "@reduxjs/toolkit";

export const dataPointValueSlice = createSlice({
    name: 'dataPointValueSlc',
    initialState: {value: {
        id: 0,
            dataPointId:null,
            mcode: null,
            name: null,
            description: null,
            ordinalNumber: null,
            exceptionInd:false,
        status: null,
            createdOn: null,
            createdBy:null,
            lastModifiedOn:null,
            lastModifiedBy:null,
        dpvDrawerState: false,
            dpvDrawerMode: null,
            dpvGridRefresh: false}},
    reducers:
{
    changeDataPointValue: (state, action) => {
        state.value = {
            ...state.value,  // Keep existing fields
            ...action.payload // Merge new values
        };
    }
}
});

export const {changeDataPointValue} = dataPointValueSlice.actions;

export default  dataPointValueSlice.reducer ;
